import React, { useState, useEffect } from "react";
import { Form, Input, Select, Button, message, Row, Col, Switch, Card } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";

const { Option } = Select;

const RedirectEdit = () => {
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    fetchRedirect();
  }, []);

  const fetchRedirect = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/panel/redirect/${id}`);
      setRedirect(response.data.data);
      form.setFieldsValue({
        ...response.data.data,
        is_active: response.data.data.is_active === 1,
      });
    } catch (error) {
      message.error("خطا در دریافت اطلاعات ری‌دایرکت");
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await api.put(`/panel/redirect/${id}`, {
        ...values,
        is_active: values.is_active ? 1 : 0,
      });
      message.success("ری‌دایرکت با موفقیت ویرایش شد");
      navigate("/redirects");
    } catch (error) {
      message.error("خطا در ویرایش ری‌دایرکت");
    } finally {
      setLoading(false);
    }
  };

  if (!redirect) return null;

  return (
    <Card title="ویرایش ری دایرکت">
    
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="source_url"
            label="آدرس مبدأ"
            rules={[{ required: true, message: "لطفاً آدرس مبدأ را وارد کنید" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="destination_url"
            label="آدرس مقصد"
            rules={[{ required: true, message: "لطفاً آدرس مقصد را وارد کنید" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="redirect_type"
            label="نوع ری‌دایرکت"
            rules={[{ required: true, message: "لطفاً نوع ری‌دایرکت را انتخاب کنید" }]}
          >
            <Select>
              <Option value="301">301 - انتقال دائمی</Option>
              <Option value="302">302 - انتقال موقت</Option>
              <Option value="307">307 - انتقال موقت (با حفظ متد)</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="maintenance_code" label="کد وضعیت">
            <Select>
              <Option value="410">410 - حذف شده</Option>
              <Option value="451">451 - غیرقابل دسترسی به دلایل قانونی</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="is_active" label="وضعیت" valuePropName="checked">
            <Switch
              checkedChildren="فعال"
              unCheckedChildren="غیرفعال"
            />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          ویرایش ری‌دایرکت
        </Button>
      </Form.Item>
    </Form>
    </Card>
  );
};

export default RedirectEdit;